import { useStyleSheet } from '../../../../../../hooks/useStyleSheet';

export const useStyles = () => {
  const styles = useStyleSheet(
    () => ({
      root: {
        display: 'grid',
        placeItems: 'center',
      },
    }),
    [],
  );

  return styles;
};
